import { Button, Modal } from 'antd';
import '../../styles/CustomModal.css';
import { bigStatusIcon } from '../../utils/svgs';

const StatusModal = ({
    open,
    onClose,
    onConfirm,
    status,
    loading = false,
    titleText,
    description,
    showConfirmButton = true,
    confirmText = 'Yes',
    cancelText,
    centered = false,
    confirmBtnClass,
    confirmBtnStyle,
}) => {

    const formattedStatus = status ? status.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase()) : '';
    const resolvedTitle = titleText || `Are you sure you want to change status to ${formattedStatus}?`;
    const resolvedDescription = description || 'This action will update the trip status.';
    const resolvedCancelText = cancelText || (showConfirmButton ? 'Cancel' : 'Close');

    const normalizedStatus = String(status || '').toLowerCase().trim();
    const isGreenAction = ['verified', 'closed', 'completed', 'in_transit', 'in-transit', 'active'].includes(normalizedStatus);
    const resolvedConfirmBtnClass = confirmBtnClass || (isGreenAction ? 'status_modal_green_btn yes_btn' : 'logout_btn yes_btn');

    const footer = (
        <>
            <Button onClick={onClose} disabled={loading}> {resolvedCancelText} </Button>
            {showConfirmButton && (
                <Button
                    type="primary"
                    onClick={onConfirm}
                    className={resolvedConfirmBtnClass}
                    style={confirmBtnStyle}
                    loading={loading}
                    disabled={loading}
                >
                    {confirmText}
                </Button>
            )}
        </>
    );
    return (
        <Modal
            footer={footer}
            title={bigStatusIcon}
            mask={{ enabled: true, blur: true }}
            open={open}
            onOk={onClose}
            onCancel={onClose}
            centered={centered}
            className="status_action_modal"
            focusTriggerAfterClose={false}
            autoFocusButton={null}
        >
            <div className="my-4 status_modal_body_content">
                <h3 className="status_modal_title">{resolvedTitle}</h3>
                <p className="status_modal_desc">{resolvedDescription}</p>
            </div>
        </Modal>
    );
};
export default StatusModal;
